import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from '../auth-guard.service';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { TestRestApiComponent } from './test-rest-api/test-rest-api.component';
import { SalesMetricsDashboardComponent } from './sales-metrics-dashboard/sales-metrics-dashboard.component';
import { PremiumOverDueComponent } from './premium-over-due/premium-over-due.component';
import { TraningsAndExamsComponent } from './tranings-and-exams/tranings-and-exams.component';

const routes: Routes = [
  { path: 'home', component: LandingPageComponent, canActivate: [AuthGuardService] },
  { path: 'salesmetrics', component: SalesMetricsDashboardComponent, canActivate: [AuthGuardService] },
  {
    path: 'restAPI-listing',
    component: TestRestApiComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'premium-over-due',
    component: PremiumOverDueComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'upcoming-tranings-and-exams',
    component: TraningsAndExamsComponent,
    canActivate: [AuthGuardService],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomeRoutingModule {}
